{
  "USERS": [
    {
      "ADMIN": {
        "ROLE_SCOPE": "CRM",
        "LABEL": "Admin"
      }
    },
    {
      "OWNER": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Owner"
      }
    },
    {
      "OEM": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Admin"
      }
    },
    {
      "STAFF": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Supervisor"
      }
    },
    {
      "TECHNICIAN": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Technician"
      }
    },
    {
      "CUSTOM": {
        "ROLE_SCOPE": "CUSTOM",
        "LABEL": "Custom"
      }
    },
    {
      "PORTAL_USER": {
        "ROLE_SCOPE": "PORTAL_USER",
        "LABEL": "Portal User"
      }
    }
  ]
}
